import { Component, Input } from '@angular/core';
import { UICard } from '@shared/ui';
import { DashboardGeneralStatisticInfoModel } from '../../models';
import { DashboardService } from '../../services/dashboard.service';

@Component({
  selector: 'aggregator-dashboard-general-info',
  templateUrl: './general-info.component.html',
  styleUrl: './general-info.component.scss',
  standalone: true,
  imports: [UICard],
  providers: [DashboardService],
})
export class DashboardGeneralInfoComponent {
  @Input() data?: DashboardGeneralStatisticInfoModel[] = [];
}
